// extracted by mini-css-extract-plugin
module.exports = {"cardPaddingsOverwrite":"SuccessView__cardPaddingsOverwrite___MvPrl","logo":"SuccessView__logo___0cBt8","illustration":"SuccessView__illustration___fyWHr"};